import AppBar from "@material-ui/core/AppBar";
import Button from "../../../components/CustomButtons/Button";
import cx from "classnames";
import Hidden from "@material-ui/core/Hidden";
import Menu from "@material-ui/icons/Menu";
import MoreVert from "@material-ui/icons/MoreVert";
import PropTypes from "prop-types";
import React from "react";
import Toolbar from "@material-ui/core/Toolbar";
import ViewList from "@material-ui/icons/ViewList";
import withStyles from "@material-ui/core/styles/withStyles";
import headerStyle from '../../../assets/jss/material-dashboard-pro-react/components/headerStyle';
import SearchBarButton from "../SearchBarButton/SearchBarButton";


function Header({ ...props }) {
    function makeBrand() {
        var name;
        props.routes.map((prop, key) => {
            if (prop.collapse) {
                prop.views.map((prop, key) => {
                    if (prop.path === props.location.pathname.replace(/\d+/, ":id")) {
                        name = prop.name;
                    }
                    return null;
                });
            }
            if (prop.path === props.location.pathname.replace(/\d+/, ":id")) {
                name = prop.name;
            }
            return null;
        });
        return name;
    }
    const { classes, color, rtlActive } = props;
    const currentLocation = makeBrand();
    const appBarClasses = cx({
        [" " + classes[color]]: color
    });
    const sidebarMinimize =
        classes.sidebarMinimize +
        " " +
        cx({
            [classes.sidebarMinimizeRTL]: rtlActive
        });

    return (
        <AppBar className={classes.appBar + appBarClasses} data-testid="header">
            <Toolbar className={classes.container}>
                <Hidden smDown implementation="css">
                    <div className={sidebarMinimize}>
                        {props.miniActive ? (
                            <Button
                                color='white'
                                justIcon
                                round
                                onClick={props.sidebarMinimize}
                                data-testid="showFullMenu"
                            >
                                <ViewList className={classes.sidebarMiniIcon} />
                            </Button>
                        ) : (
                            <Button
                                color='white'
                                justIcon
                                round
                                onClick={props.sidebarMinimize}
                                data-testid="showMiniMenu"
                            >
                                <MoreVert className={classes.sidebarMiniIcon} />
                            </Button>
                        )}
                    </div>
                </Hidden>
                <div className={classes.flex}>
                    {/* Here we create navbar brand, based on route name */}
                    <Button href="#" className={classes.title} color="transparent">
                        {makeBrand()}
                    </Button>
                </div>
                <Hidden smDown implementation="css">
                    <div style={{ display: 'flex ' }}>
                        <SearchBarButton location={currentLocation} />
                    </div>
                </Hidden>
                <Hidden mdUp implementation="css">
                    <div style={{ display: 'flex ' }}>
                        <SearchBarButton location={currentLocation} />
                        <Button
                            className={classes.appResponsive}
                            color="transparent"
                            justIcon
                            aria-label="open drawer"
                            onClick={props.handleDrawerToggle}
                        >
                            <Menu />
                        </Button>
                    </div>
                </Hidden>
            </Toolbar>
        </AppBar>
    );
}

Header.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
    rtlActive: PropTypes.bool
};

export default withStyles(headerStyle)(Header);